import styled, {css} from 'styled-components';

const subColor = 'grey';
const mainColor = 'black';


export const shrinkLabelStyles = css`
 top: -14px;
font-size: 14px;
color: ${mainColor};
outline:none;

`

export const FormInputLabel = styled.label`
        color: ${subColor};
        font-size: 16px;
        font-weight: normal;
        position: absolute;
        pointer-events: none;
        left: 5px;
        top: 10px;
        transition: 300ms ease all;
        ${({shrink}) => shrinkLabelStyles}
`

export const Input = styled.input`
        background: none;
        background-color: white;
        color: $sub-color;
        font-size: 19px;
        padding: 10px 10px 10px 5px;
        display: block;
        width: 100%;
        border: none;
        border-radius:0;
        border-bottom: 1px solid ${subColor};
        margin: 25px 0;

    &:focus{
        outline:none;
    }
    &:focus ~ ${FormInputLabel}{
        ${shrinkLabelStyles}
`

export const Group = styled.div`
position:relative;
margin: 45px 0;
`

// $sub-color:grey;
// $main-color: black;

// @mixin shrinkLabel{
//     top: -14px;
//     font-size: 14px;
//     color: $main-color;
//     outline:none;
// }

// .group{
//     position:relative;
//     margin: 45px 0;
//     .form-input{
//         background: none;
//         background-color: white;
//         color: $sub-color;
//         font-size: 19px;
//         padding: 10px 10px 10px 5px;
//         display: block;
//         width: 100%;
//         border: none;
//         border-radius:0;
//         border-bottom: 1px solid $sub-color;
//         margin: 25px 0;
//     }
//     &:focus{
//         outline:none;
//     }
//     &:focus ~ .form-input-label{
//         @include shrinkLabel()
//     }
//     input[type="password"]{
//         letter-spacing: 0.3em;
//     }
//     .form-input-label{
//         color: $sub-color;
//         font-size: 16px;
//         font-weight: normal;
//         position: absolute;
//         pointer-events: none;
//         left: 5px;
//         top: 10px;
//         transition: 300ms ease all;
//         &.shrink{
//             @include shrinkLabel()
//         }
//     }
// }
